module.exports = __webpack_public_path__ + "img/wireframes_01.1f2350c1.png";